export default __webpack_public_path__ + "static/media/draft_background.ab117e6d.png";